import { state } from '../state.js';
import { renderTopics } from '../attendance/topics.js';
import { renderChildrenList } from '../attendance/children.js';

export const savePreferences = () => {
    const view = document.querySelector('.topics-column')?.classList.contains('show-children')
        ? 'children'
        : 'topics';
    fetch(`${window.AppSettings.uriRoot}ajax/save_preferences`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            church_id: state.currentChurch,
            group_id:  state.currentGroup,
            view,
        }),
    }).catch(() => {});
};

export const updateChurchUI = (churchId, savedGroupId = null) => {
    const churchData = state.getChurch(churchId);
    if (!churchData) return;

    state.currentChurch = churchId;

    // 1. Update Logo (Avatar)
    const avatarImg = document.querySelector('.app-sidebar__header__avatar');
    if (avatarImg && churchData.logo_url) {
        avatarImg.src = churchData.logo_url;
        avatarImg.alt = `Logo ${churchData.name}`;
    }

    // 2. Update Role Label (Catechist: Name -> Role: Name)
    const roleElement = document.querySelector('.app-sidebar__info__user');
    if (roleElement) {
        const userName = window.AppSettings.activeUser?.name || "User";;
        roleElement.textContent = `${churchData.role_label}: ${userName}`;
    }

    // 3. Update dropdown text
    const currentText = document.querySelector('#churchSelector .c-dropdown__current');
    if (currentText) {
        currentText.textContent = churchData.name;
    }

    // 4. Render its groups
    const churchLevels = state.getChurchLevels(churchData.id);
    renderGroups(churchLevels, savedGroupId);
};

export const loadChurches = (saved = null) => {
    const dropdownList = document.querySelector('#churchSelector .c-dropdown__list');
    const churches = state.data.churches;

    if (churches && churches.length > 0) {
        dropdownList.innerHTML = churches.map(church => `
            <li class="c-dropdown__item" data-id="${church.id}">
                ${church.name}
            </li>
        `).join('');

        // Use saved church if it still exists, otherwise fall back to first
        const savedChurchId = saved?.churchId;
        const churchToLoad = savedChurchId && churches.some(c => c.id === savedChurchId)
            ? savedChurchId
            : churches[0].id;

        updateChurchUI(churchToLoad, saved?.groupId ?? null);
    }
};

const setHeaderTitle = (title) => {
    const headerTitle = document.getElementById('headerTitle');
    if (headerTitle) headerTitle.textContent = title;
};

const renderCurrentView = (groupId) => {
    state.currentGroup = groupId;
    savePreferences();
    const topicsColumn = document.querySelector('.topics-column');
    if (topicsColumn?.classList.contains('show-children')) {
        renderChildrenList(groupId);
    } else {
        renderTopics(groupId);
    }
};

export const renderGroups = (levels, savedGroupId = null) => {
    const menuContainer = document.querySelector('.app-menu');
    if (!menuContainer) return;

    menuContainer.innerHTML = '';

    const sidebar = document.getElementById('appSidebar');
    const overlay = document.getElementById('sidebarOverlay');
    let firstGroupId = null;

    // Collect all group IDs in this church to validate savedGroupId
    const allGroupIds = levels.flatMap(l => l.groups.map(g => g.id));
    const groupToRestore = savedGroupId && allGroupIds.includes(savedGroupId) ? savedGroupId : null;

    levels.forEach((level) => {
        level.groups.forEach((groupLevel) => {
            const group = state.getGroup(groupLevel.id);
            const li = document.createElement('li');

            if (firstGroupId === null) firstGroupId = group.id;

            // Mark the restored/saved group as active; fall back to first group
            const isActive = groupToRestore ? group.id === groupToRestore : group.id === firstGroupId;
            const activeClass = isActive ? 'active' : '';

            li.innerHTML = `
                <div class="app-menu__item ${activeClass}" data-id="${group.id}">
                    <i class="bi bi-calendar3"></i>
                    <span class="app-menu__label">${group.title}</span>
                </div>
            `;

            // Group click event
            li.querySelector('.app-menu__item').addEventListener('click', (e) => {
                document.querySelectorAll('.app-menu__item').forEach(el => el.classList.remove('active'));
                e.currentTarget.classList.add('active');

                // Close sidebar on mobile
                if (window.innerWidth < 768) {
                    sidebar?.classList.remove('is-active');
                    overlay?.classList.remove('is-active');
                    document.body.style.overflow = '';
                }

                setHeaderTitle(group.title);
                renderCurrentView(group.id);
            });

            menuContainer.appendChild(li);
        });
    });

    // Auto-load the restored group (or first group) and show the view toggle
    const autoLoadId = groupToRestore ?? firstGroupId;
    if (autoLoadId) {
        setHeaderTitle(state.getGroup(autoLoadId).title);
        document.getElementById('headerViewToggle')?.classList.remove('header-toggle-hidden');
        document.getElementById('adminGearLink')?.classList.remove('header-admin-hidden');
        document.getElementById('dashboardLink')?.classList.add('header-dashboard-hidden');
        renderCurrentView(autoLoadId);
    }
};
